module.exports = __webpack_public_path__ + "img/cooler-master-mb511-argb-preview.c44173cb.png";